export default "__VITE_ASSET__FsX56MwM__"